var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Delete---Updated",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(9.000000, 7.000000)",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10.05,
    y1: 14,
    x2: 10.05,
    y2: 6,
    id: "d254fe4e-1b6f-46e2-a7c2-d42ba0df52b9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.05,
    y1: 14,
    x2: 7.05,
    y2: 6,
    id: "1ed0b791-a61f-49c1-bcc5-b69c9e1c2f3a",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.05,
    y1: 14,
    x2: 4.05,
    y2: 6,
    id: "ea6b814f-380a-495e-b8e4-8286c3946230",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 3.05,
    x2: 14,
    y2: 3.05,
    id: "72fda49e-6123-4960-bc95-ec155c04c3a3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3 L9,2 C9,0.8954305 8.25380792,0 7.33333333,0 L5.66666667,0 C4.74619208,0 4,0.8954305 4,2 L4,3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3 L13,15.6875 C13,16.4123737 12.3800866,17 11.6153846,17 L2.38461538,17 C1.61991342,17 1,16.4123737 1,15.6875 L1,3",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.18411d10fa5d85d0518bc52b704a46de.svg";
export { ForwardRef as ReactComponent };